import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  progress: false,
};

const progressSlice = createSlice({
  name: 'progressSlice',
  initialState,
  reducers: {
    setProgress: (state, action) => {
      state.progress = action?.payload;
    },
  },
});

export const { setProgress } = progressSlice.actions;

export default progressSlice.reducer;
